import { render, staticRenderFns } from "./BackProduct.vue?vue&type=template&id=94e5b566&scoped=true"
import script from "./BackProduct.vue?vue&type=script&lang=js"
export * from "./BackProduct.vue?vue&type=script&lang=js"
import style0 from "./BackProduct.vue?vue&type=style&index=0&id=94e5b566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5b566",
  null
  
)

export default component.exports